import { render, staticRenderFns } from "./ViewProfileInfo.vue?vue&type=template&id=0030052a&scoped=true&"
import script from "./ViewProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ViewProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030052a",
  null
  
)

export default component.exports